import { Order } from "views/main/types/order";
import { StepCd } from "types/stepCd.types";
/**
 * 주문 유형 선 체크
 */
import { MobileOrderFg } from "types";

export const PARTNER_TYPE_GROUPS = {
  // 배달앱 대형 3사 주문
  EXPRESS_PARTNERS: new Set(["BAEMINONE", "YOGIYOEXPRESS", "COUPANG", "DDANGBAEDAL"]),

  // 후킹 주문 > (08, 22)
  HOOKING_ORDER: new Set([MobileOrderFg.ONETOSS_HOOKING, MobileOrderFg.HOOKING]),

  // 선불 주문 > (20, 23, 27, 31, 33, 34, 35, 36, 38, 39, 40, 41, 43, 44, 45, 47, 49, 50)
  PAID_ORDER: new Set([
    MobileOrderFg.NAVER,
    MobileOrderFg.YOGIYO,
    MobileOrderFg.HUNGRY_PANDA,
    MobileOrderFg.WMPO,
    MobileOrderFg.DDANGYO,
    MobileOrderFg.BMSMILE,
    MobileOrderFg.MUKKEBI,
    MobileOrderFg.GAMSUNG_COFFEE,
    MobileOrderFg.HASAMDONG_COFFEE,
    MobileOrderFg.BAEGEOK_COFFEE,
    MobileOrderFg.OLTTEA_AH,
    MobileOrderFg.TALK_PICK,
    MobileOrderFg.THE_LITER,
    MobileOrderFg.ROUTINE_COFFEE,
    MobileOrderFg.DEMONSTRATION,
    MobileOrderFg.NAVER_BOOKING,
  ]),
};

// 재호출 가능한 주문 > (36, 43, 44, 45, 49, 50)
export const RECALL_VALID_ORDER = new Set([
  MobileOrderFg.BMSMILE,
  MobileOrderFg.GAMSUNG_COFFEE,
  MobileOrderFg.HASAMDONG_COFFEE,
  MobileOrderFg.BAEGEOK_COFFEE,
  MobileOrderFg.OLTTEA_AH,
  MobileOrderFg.TALK_PICK,
  MobileOrderFg.ROUTINE_COFFEE,
  MobileOrderFg.DEMONSTRATION,
]);

// O2O 공통 스펙 주문
export const COMMON_O2O_ORDER = new Set([
  MobileOrderFg.YOGIYO,
  MobileOrderFg.WMPO,
  MobileOrderFg.DDANGYO,
  MobileOrderFg.DDANGBAEDAL,
  MobileOrderFg.BMSMILE,
  MobileOrderFg.MUKKEBI,
]);

// 조리완료 가능한 주문 > (31, 32, 33)
export const COOKING_COMPLETE_VALID_ORDER = new Set([MobileOrderFg.PANDA_SELF_DELIVERY, MobileOrderFg.HUNGRY_PANDA,]);

export const isExpressDeliveryOrder = (order: Order): boolean => {
  if (!order.partnerType) return false;
  return PARTNER_TYPE_GROUPS.EXPRESS_PARTNERS.has(order.partnerType);
};

export const isHookingOrder = (order: Order): boolean => {
  if (!order.mobileOrderFg) return false;
  return PARTNER_TYPE_GROUPS.HOOKING_ORDER.has(order.mobileOrderFg);
};

export const isPaidOrder = (order: Order): boolean => {
  if (!order.mobileOrderFg) return false;
  return PARTNER_TYPE_GROUPS.PAID_ORDER.has(order.mobileOrderFg);
};

export const isRecallValidOrder = (order: Order): boolean => {
  if (!order.mobileOrderFg) return false;
  return order.stepCd === StepCd.PICKUP_REQUEST && RECALL_VALID_ORDER.has(order.mobileOrderFg);
};

export const isCookingCompleteValidOrder = (order: Order): boolean => {
  if (!order || !order.mobileOrderFg) {
    return false;
  }

  const { mobileOrderFg, dlvStatusFg } = order;

  if (mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS) {
    return dlvStatusFg ? ["00", "02"].includes(dlvStatusFg) : false;
  }

  return COOKING_COMPLETE_VALID_ORDER.has(mobileOrderFg);
};

export const isCommonO2OOrder = (order: Order): boolean => {
  if (!order.mobileOrderFg) return false;

  /**
   * mobileOrderFg가 40번 이상이면 새로 추가되는 제휴사로 간주하여 공통 O2O 로직 처리
   * COMMON_O2O_ORDER에 별도 추가하지 않아도 자동으로 공통 로직을 탐
   * (큰 이변이 없는 한 앞으로 추가되는 제휴사들은 40번 이상 번호를 부여)
   */
  return Number(order.mobileOrderFg) > 40 || COMMON_O2O_ORDER.has(order.mobileOrderFg);
};
